export default "__VITE_PUBLIC_ASSET__8c7983f4__"